export const isFree = 'isFree';
